import React from 'react'
import { useTranslation } from 'react-i18next'

import { InfoModal } from '@global/modal/InfoModal'
import { Modal } from '@global/modal/Modal'

import styles from '../CompanyDetailsStep.module.scss'

interface PrimaryContactModalProps {
  onClose(): void
}

export const PrimaryContactModal: React.FC<PrimaryContactModalProps> = (props) => {
  const { onClose } = props

  const { t } = useTranslation()

  return (
    <Modal
      cardClassName={styles.modal}
      closeModal={onClose}
      render={({ closeModal }) => (
        <InfoModal
          onCancel={closeModal}
          title={t('Sign up.Primary Contact')}
          renderBody={() => (
            <section className='modal-card-body'>
              <p
                dangerouslySetInnerHTML={{
                  __html: t('Sign up.Person responsible for on-going administrative purposes'),
                }}
              />
            </section>
          )}
          renderFooter={() => (
            <button className='button' onClick={onClose} type='button'>
              <b>{t('Got It')}</b>
            </button>
          )}
          onConfirm={onClose}
        />
      )}
    />
  )
}
